import Actions               from 'Redux/Actions';
import { InvoiceRepository } from 'Domain/Repositories';
import { ofType }            from 'redux-observable';
import { from, EMPTY }       from 'rxjs';
import { mergeMap }          from 'rxjs/operators';
import { TEpic }             from 'Redux/Config';
import { message }           from 'antd';

export const sendTicketsFromInvoiceEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.sendTicketsFromInvoiceRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        InvoiceRepository.sendTicketsFromInvoice(id)
          .then(() => {
            message.success('Tickets wurden erfolgreich versendet.');
            return Actions.sendTicketsFromInvoiceSuccess();
          })
          .catch(error => Actions.sendTicketsFromInvoiceFailure({ error })),
      );
    }),
  );
};
